import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { logger } from 'shared/utils/logger';
import { UnFormalizedZip, UnFormalizedZipListItem, UnFormalizedZipStateType } from '../types/types';
import {
  getAllUnFormalizedZips, getUnFormalizedZipById, getUnFormalizedZipsByEngineId,
  createUnFormalizedZip, updateUnFormalizedZip, deleteUnFormalizedZip,
} from '../actions/actions';

const initialState: UnFormalizedZipStateType = {
  unFormalizedZips: [],
  unFormalizedZipDetail: {
    isLoading: false,
    data: null,
  },
  isLoading: false,
};

const slice = createSlice({
  name: 'unFormalizedZip',
  initialState,
  reducers: {
    dropDetailData(state: UnFormalizedZipStateType) {
      state.unFormalizedZipDetail.data = null;
    },
  },
  extraReducers(builder) {
    builder.addCase(getAllUnFormalizedZips.pending, (state: UnFormalizedZipStateType) => {
      state.isLoading = true;
    });
    builder.addCase(
      getAllUnFormalizedZips.fulfilled,
      (state: UnFormalizedZipStateType, action: PayloadAction<UnFormalizedZipListItem[]>) => {
        state.unFormalizedZips = action.payload;
        state.isLoading = false;
      },
    );
    builder.addCase(getAllUnFormalizedZips.rejected, (state: UnFormalizedZipStateType, action) => {
      logger.error('unFormalizedZip/getAllUnFormalizedZips', action.payload);
      state.isLoading = false;
    });

    builder.addCase(getUnFormalizedZipById.pending, (state: UnFormalizedZipStateType) => {
      state.unFormalizedZipDetail.isLoading = true;
    });
    builder.addCase(getUnFormalizedZipById.fulfilled, (state: UnFormalizedZipStateType, action: PayloadAction<UnFormalizedZip>) => {
      state.unFormalizedZipDetail.data = action.payload;
      state.unFormalizedZipDetail.isLoading = false;
    });
    builder.addCase(getUnFormalizedZipById.rejected, (state: UnFormalizedZipStateType, action) => {
      logger.error('unFormalizedZip/getUnFormalizedZipById', action.payload);
      state.unFormalizedZipDetail.isLoading = false;
    });

    builder.addCase(getUnFormalizedZipsByEngineId.pending, (state: UnFormalizedZipStateType) => {
      state.isLoading = true;
    });
    builder.addCase(
      getUnFormalizedZipsByEngineId.fulfilled,
      (state: UnFormalizedZipStateType, action: PayloadAction<UnFormalizedZipListItem[]>) => {
        state.unFormalizedZips = action.payload;
        state.isLoading = false;
      },
    );
    builder.addCase(getUnFormalizedZipsByEngineId.rejected, (state: UnFormalizedZipStateType, action) => {
      logger.error('unFormalizedZip/getUnFormalizedZipsByEngineId', action.payload);
      state.isLoading = false;
    });

    builder.addCase(createUnFormalizedZip.pending, (state: UnFormalizedZipStateType) => {
      state.isLoading = true;
    });
    builder.addCase(createUnFormalizedZip.fulfilled, (state: UnFormalizedZipStateType) => {
      state.isLoading = false;
    });
    builder.addCase(createUnFormalizedZip.rejected, (state: UnFormalizedZipStateType, action) => {
      logger.error('unFormalizedZip/createUnFormalizedZip', action.payload);
      state.isLoading = false;
    });

    builder.addCase(updateUnFormalizedZip.pending, (state: UnFormalizedZipStateType) => {
      state.isLoading = true;
    });
    builder.addCase(updateUnFormalizedZip.fulfilled, (state: UnFormalizedZipStateType) => {
      state.isLoading = false;
    });
    builder.addCase(updateUnFormalizedZip.rejected, (state: UnFormalizedZipStateType, action) => {
      logger.error('unFormalizedZip/updateUnFormalizedZip', action.payload);
      state.isLoading = false;
    });

    builder.addCase(deleteUnFormalizedZip.pending, (state: UnFormalizedZipStateType) => {
      state.isLoading = true;
    });
    builder.addCase(deleteUnFormalizedZip.fulfilled, (state: UnFormalizedZipStateType) => {
      state.isLoading = false;
    });
    builder.addCase(deleteUnFormalizedZip.rejected, (state: UnFormalizedZipStateType, action) => {
      logger.error('unFormalizedZip/deleteUnFormalizedZip', action.payload);
      state.isLoading = false;
    });
  },
});

export const unFormalizedZipActions = slice.actions;
export default slice.reducer;
